module.exports = __webpack_public_path__ + "img/chat-message.27780083.svg";